import { User } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const UsernameListItem = ({ username, center }: { username: string; center: string }) => {
  const { t } = useTranslation('auth', { keyPrefix: 'forgotUsernameList.list' });

  return (
    <div className='flex gap-8 break-all'>
      <div className='bg-fill-background-light size-11 rounded-lg p-3' aria-hidden>
        <User size={20} />
      </div>
      <div className='flex flex-col gap-4'>
        <div className='flex flex-col gap-1'>
          <span className='text-text-default-secondary'>{t('username')}:</span>
          <span>{username}</span>
        </div>
        <div className='flex flex-col gap-1'>
          <span className='text-text-default-secondary'>{t('center')}:</span>
          <span>{center}</span>
        </div>
      </div>
    </div>
  );
};
